// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__aPFWb","label":"Modal_label__n+0dC","error":"Modal_error__-w9Z1","submit":"Modal_submit__xO-eq"};